import { Box, useMantineTheme, Skeleton } from "@mantine/core";

import CardWrapper from "_components/atoms/cardWrapper";
import useStyles   from "_styles/templates/RecommendationList";

export const SkeletonView = ( { carousel, customStyles = {}, customContainerStyle = {} } ) => {
	const { classes } = useStyles ( undefined, { name: "styles" } );
	const theme       = useMantineTheme ();

	return (
		<div className = { classes.skeletonContainer }
			style = { customContainerStyle }
		>
			<CardWrapper customStyles = { { background: "none" } }>

				<Box
					sx = { {
						padding    : "0px",
						display    : "flex",
						background : "none !important",
						...customStyles
					} }
				>

					<Skeleton animate = { true }
						height = { "unset" }
						radius = "lg"
						style = { { opacity: !theme.other.darkMode ? "80%" : "20%", margin: "2px", aspectRatio: "16/9" } }
						width = { carousel ? undefined : "48%" }
					/>

					<div style = { { width: "200px", paddingLeft: "10px" } }>
						<Skeleton animate = { true }
							height = { 20 }
							radius = "lg"
							style = { { margin: "8px 0", opacity: !theme.other.darkMode ? "80%" : "20%" } }
							width = "90%"
						/>

						<Skeleton animate = { true }
							height = { 20 }
							radius = "lg"
							style = { { margin: "8px 0", opacity: !theme.other.darkMode ? "80%" : "20%" } }
							width = "40%"
						/>

						<Skeleton animate = { true }
							height = { 20 }
							radius = "lg"
							style = { { margin: "8px 0", opacity: !theme.other.darkMode ? "80%" : "20%" } }
							width = "50%"
						/>

					</div>
				</Box>
			</CardWrapper>
		</div>
	);
};
